import { useEffect, useState } from 'react';
import { useAppContext } from '@/context/context';
import instanceAxios from '@/util/axios';
import { branchsPolygonAndCenterUrl } from '@/constants';

export interface BranchPolygonData {
  position: {
    lat: number;
    lng: number;
  };
  coordinates: number[][] | number[][][]; // Can be array of points or array of arrays of points
}

/**
 * Hook to fetch the polygon boundary for the current user's branch
 * @returns {polygon, loading, error}
 */
export const useBranchPolygon = () => {
  const { shaliach } = useAppContext();
  const [polygon, setPolygon] = useState<BranchPolygonData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    const fetchPolygon = async () => {
      // Check if user has a branch
      const branchId = shaliach?.Branch?.id;
      
      if (!branchId) {
        // No branch - silently skip
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const { data } = await instanceAxios.get(`${branchsPolygonAndCenterUrl}/${branchId}`);
        console.log('Branch polygon loaded:', { 
          branchId, 
          hasCoordinates: !!data?.coordinates, 
          coordinatesLength: data?.coordinates?.length,
          firstArrayLength: data?.coordinates?.[0]?.length,
          samplePoint: data?.coordinates?.[0]?.[0]
        });
        setPolygon(data);
      } catch (err) {
        // Silent error handling as requested
        console.warn('Failed to load branch polygon:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPolygon();
  }, [shaliach?.Branch?.id]);

  return {
    polygon,
    loading,
    error
  };
};
